import { tr } from "@/warRoom/lib/i18n";

export type ChartType =
  | "line"
  | "area"
  | "column"
  | "bar"
  | "stackedColumn"
  | "stackedBar"
  | "groupedColumn"
  | "pie"
  | "scatter"
  | "heatmap";

/**
 * countDistinct（相異數）是「非量值欄位也能當 Y 軸」的那條路：
 * 文字／日期加總沒有意義，但「有幾個不同的值」有。
 */
export type Aggregation =
  | "count"
  | "sum"
  | "avg"
  | "min"
  | "max"
  | "countDistinct";

export type TimeGrain = "day" | "week" | "month" | "quarter" | "year";

export type SortBy = "x" | "valueDesc" | "valueAsc";

export type GraphSpec = {
  datasetKey: string | null;
  chartType: ChartType | null;
  /** 類別／時間軸欄位（scatter 時是 X 量值欄位） */
  xField: string | null;
  /**
   * Y 量值欄位。null 代表 count（筆數）。
   * 刻意只有一個 —— 兩個不同尺度的量值放同一張圖就是雙軸，
   * 那會憑空造出假的相關性。要比兩個量值請開兩張圖或用散佈圖。
   */
  yField: string | null;
  aggregation: Aggregation;
  /** 數列來自「維度欄位」，不是第二個量值 —— 這是擋掉雙軸的結構性設計 */
  seriesField: string | null;
  timeGrain: TimeGrain;
  /** 只留前 N 名，其餘折成「其他」。0 = 全部 */
  topN: number;
  sortBy: SortBy;
  /** 時間篩選用哪個欄位 */
  dateField: string | null;
  /** [起, 迄] ISO date，含端點 */
  dateRange: [string, string] | null;
  /** 維度篩選：欄位 key → 允許的原始值。空陣列 = 不篩這個欄位 */
  dimFilters: Record<string, string[]>;
};

export const emptySpec: GraphSpec = {
  datasetKey: null,
  chartType: null,
  xField: null,
  yField: null,
  aggregation: "count",
  seriesField: null,
  timeGrain: "month",
  topN: 12,
  sortBy: "valueDesc",
  dateField: null,
  dateRange: null,
  dimFilters: {},
};

export const otherLabel = () => tr("warRoom.common.other");
